/**
 * Σειρά αποτελεσμάτων του Pandaki:
 * 1) Άμεσα διαθέσιμα (αν υπάρχουν)
 * 2) Προσφορές (όσα δείχνουν διαγραμμένη «πριν» τιμή)
 * 3) Τα υπόλοιπα
 *
 * Μέσα σε κάθε ομάδα διατηρείται η σειρά συνάφειας της αναζήτησης —
 * το φίλτρο μετακινεί ολόκληρες ομάδες, δεν ανακατεύει αποτελέσματα.
 */

export type PandakiRankable = {
  availability?: string | null;
  price?: number | null;
  original_price?: number | null;
};

/** «άμεσα» με/χωρίς τόνους, πεζά/κεφαλαία — ίδια αναγνώριση με τα badges του eshop. */
const plain = (s: string | null | undefined) =>
  (s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function isImmediatelyAvailable(p: PandakiRankable): boolean {
  return plain(p.availability).includes("αμεσα");
}

/** Ίδια συνθήκη με το «διαγραμμένη τιμή» της κάρτας προϊόντος. */
export function isOnOffer(p: PandakiRankable): boolean {
  return p.original_price != null && Number(p.original_price) > Number(p.price ?? 0);
}

function groupOf(p: PandakiRankable): number {
  if (isImmediatelyAvailable(p)) return 0;
  if (isOnOffer(p)) return 1;
  return 2;
}

/** Ομαδοποιεί χωρίς να αλλάζει τη σχετική σειρά μέσα σε κάθε ομάδα. */
export function orderPandakiResults<T extends PandakiRankable>(items: T[]): T[] {
  const groups: T[][] = [[], [], []];
  for (const item of items) groups[groupOf(item)].push(item);
  return [...groups[0], ...groups[1], ...groups[2]];
}
